import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, State } from 'app/virtual-event/features';

export const selectVirtualEventState = createFeatureSelector<State>(
  featureKey
);

export const selectVirtualEventData = createSelector(
  selectVirtualEventState,
  (state: State) => state.data
);

export const selectVirtualEventSelectedCampaign = createSelector(
  selectVirtualEventData,
  (data: any) => {
    return _.get(data, 'currentItem.campaignData', {});
  }
);

export const selectVirtualEventSelectedOption = createSelector(
  selectVirtualEventData,
  (data: any) => {
    return _.get(data, 'currentItem.optionInfo', {});
  }
);

export const selectVirtualEventLastHero = createSelector(
  selectVirtualEventState,
  (state: State) => state.lastHero
);

export const selectVirtualEventSponsorSearch = createSelector(
  selectVirtualEventData,
  (state: any) => {
    return state.sponsorSearch;
  }
)

export const selectVirtualEventSlideSearch = createSelector(
  selectVirtualEventData,
  (state: any) => {
    return state.slideSearch;
  }
)
